import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SentinelPage = () => {
  const articles = [
    {
      slug: '/sentinel/sentinel-kurulum-rehberi',
      tag: 'Kurulum',
      date: '15 Ekim 2025',
      readTime: '12 dk okuma',
      title: 'Microsoft Sentinel Kurulum Rehberi: Sıfırdan SIEM Yapılandırması',
      description:
        'Azure Sentinel\'i sıfırdan kurun, veri kaynaklarını bağlayın ve ilk analitik kurallarınızı oluşturun.',
      image:
        'https://public.readdy.ai/ai/img_res/582f1a1de89473053b7bf778a098b3e8.jpg',
      icon: 'ri-settings-3-line',
      accent: 'from-[#0078D4] to-[#005A9E]',
      accentBg: 'bg-[#0078D4]',
    },
    {
      slug: '/sentinel/sentinel-maliyet-optimizasyonu',
      tag: 'Maliyet',
      date: '22 Kasım 2025',
      readTime: '10 dk okuma',
      title: 'Sentinel Maliyet Optimizasyonu: Log Yönetimi ve Bütçe Kontrolü',
      description:
        'Log Analytics maliyetlerini optimize edin, gereksiz verileri filtreleyin ve bütçe alarmları kurun.',
      image:
        'https://readdy.ai/api/search-image?query=financial%20cost%20optimization%20dashboard%20with%20glowing%20blue%20bar%20charts%20and%20pie%20graphs%20showing%20decreasing%20cloud%20expenses%20and%20budget%20analytics%20on%20dark%20modern%20interface%20with%20abstract%20data%20visualization%20and%20money%20saving%20icons&width=800&height=500&seq=sentinel-cost-2&orientation=landscape',
      icon: 'ri-money-dollar-circle-line',
      accent: 'from-[#00BCF2] to-[#0078D4]',
      accentBg: 'bg-[#00BCF2]',
    },
    {
      slug: '/sentinel/soar-logic-apps',
      tag: 'Otomasyon',
      date: '3 Aralık 2025',
      readTime: '18 dk okuma',
      title: 'Microsoft Sentinel SOAR: Olay Müdahale Süreçlerini Otomatize Etmek - Bölüm 1',
      description:
        'SOAR ekosistemi ile güvenlik olaylarına otomatik yanıt verin, Logic Apps entegrasyonu yapın ve playbook\'lar oluşturun.',
      image:
        'https://readdy.ai/api/search-image?query=automated%20security%20orchestration%20workflow%20visualization%20with%20glowing%20blue%20robotic%20arms%20and%20interconnected%20logic%20flow%20diagrams%20showing%20automated%20incident%20response%20playbooks%20on%20dark%20futuristic%20dashboard%20with%20abstract%20automation%20gears%20and%20AI%20neural%20network%20patterns&width=800&height=500&seq=sentinel-soar-automation-3&orientation=landscape',
      icon: 'ri-rocket-line',
      accent: 'from-[#7B68EE] to-[#0078D4]',
      accentBg: 'bg-[#7B68EE]',
    },
  ];

  const externalArticles = [
    {
      title: 'AI+ML+SIEM = Azure Sentinel – Azure Sentinel Yetenekleri – Bölüm 1',
      description:
        'Azure Sentinel nedir, ne işe yarar ve SIEM dünyasında nasıl bir devrim yaratıyor? Bu makalede Sentinel\'in veri toplama kanalları, yapay zekâ destekli tehdit algılama yetenekleri ve kurumsal güvenlik ekiplerine sunduğu kuşbakışı görünüm detaylı şekilde ele alınıyor.',
      url: 'https://www.mshowto.org/ai-ml-siem-azure-sentinel-azure-sentinel-yetenekleri-bolum-1.html',
      image: 'https://www.mshowto.org/images/articles/2019/03/032019_2303_AIMLSIEMAz1.png',
      date: '21 Mart 2019',
      source: 'mshowto.org',
      tag: 'Azure Sentinel',
      icon: 'ri-brain-line',
      accentBg: 'bg-[#0078D4]',
      accent: 'from-[#0078D4] to-[#005A9E]',
    },
    {
      title: 'AI+ML+SIEM = Azure Sentinel – Bölüm 2 – Kaynakları Bağlama (Office 365)',
      description:
        'Azure Sentinel\'e Office 365 kaynaklarını nasıl bağlarsınız? Bu makalede "Office 365 Connector" ile Exchange ve SharePoint aktivitelerini Sentinel\'e entegre etme adımları, Log Analytics yapılandırması ve ilk tehdit sinyallerini yakalamak için gerekli kurulum detaylıca anlatılıyor.',
      url: 'https://www.mshowto.org/aimlsiem-azure-sentinel-bolum-2-kaynaklari-baglama-office-365.html',
      image: 'https://www.mshowto.org/images/articles/2019/03/032019_2303_AIMLSIEMAz1.png',
      date: '2019',
      source: 'mshowto.org',
      tag: 'Azure Sentinel',
      icon: 'ri-plug-line',
      accentBg: 'bg-[#0078D4]',
      accent: 'from-[#0078D4] to-[#005A9E]',
    },
    {
      title: 'Azure Sentinel – Bölüm 3 – Kusto Query Language (KQL)',
      description:
        'Azure Sentinel\'in altyapısında yer alan Log Analytics ve Kusto Query Language (KQL) nedir? Bu makalede KQL\'in "big data" için geliştirilmiş read-only sorgu yapısı, Office 365 aktivitelerini sorgulama örnekleri ve Exchange üzerinde şüpheli komutları tespit etme yöntemleri adım adım anlatılıyor.',
      url: 'https://www.mshowto.org/azure-sentinel-bolum-3-kusto-query-language-kql.html',
      image: 'https://www.mshowto.org/images/articles/2019/03/032619_0738_AzureSentin4.png',
      date: '27 Mart 2019',
      source: 'mshowto.org',
      tag: 'KQL',
      icon: 'ri-code-s-slash-line',
      accentBg: 'bg-[#0078D4]',
      accent: 'from-[#0078D4] to-[#005A9E]',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#0078D4] to-[#005A9E] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
            }}
          />
        </div>
        <div className="relative max-w-6xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-lg mb-6">
              <span className="text-white text-sm font-medium">Microsoft Security</span>
            </div>
            <h1 className="text-5xl font-bold text-white mb-6">Microsoft Sentinel</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Bulut tabanlı SIEM ve SOAR çözümü hakkında derinlemesine teknik makaleler
            </p>
          </motion.div>
        </div>
      </section>

      {/* Makaleler Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Sentinel Makaleleri</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Microsoft Sentinel ile ilgili derinlemesine teknik makaleler ve rehberler
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Yeni Makale - OpenClaw AI Ajanları */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <Link
                to="/sentinel/openclaw-ai-ajanlar"
                className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer h-full"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Futuristic%20autonomous%20AI%20robot%20agent%20working%20on%20multiple%20computer%20screens%20in%20modern%20cybersecurity%20operations%20center%2C%20digital%20neural%20network%20connections%2C%20holographic%20interface%20with%20code%20and%20security%20alerts%2C%20purple%20and%20blue%20ambient%20lighting%2C%20professional%20technology%20illustration%20showing%20AI%20automation%20and%20security%20monitoring%2C%20abstract%20digital%20workspace%20concept&width=800&height=450&seq=openclaw-card&orientation=landscape"
                    alt="OpenClaw AI Ajanları"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-purple-500 text-white text-xs font-semibold rounded-full">
                      Yapay Zeka Güvenliği
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0078D4] transition-colors">
                    Otonom Yapay Zeka Ajanları İş Başında: OpenClaw'ın Faydaları ve Siber Güvenlik Riskleri
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                    OpenClaw gibi otonom AI ajanlarının kurumsal operasyonlardaki faydaları, güvenlik riskleri ve Sentinel ile tehdit avcılığı stratejileri.
                  </p>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span className="flex items-center space-x-1">
                      <i className="ri-calendar-line"></i>
                      <span>5 Mart 2026</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <i className="ri-time-line"></i>
                      <span>12 dk okuma</span>
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>

            {/* SOAR Logic Apps */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <Link
                to="/sentinel/soar-logic-apps"
                className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer h-full"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20operations%20center%20dashboard%20with%20automated%20workflow%20orchestration%2C%20featuring%20interconnected%20blue%20and%20purple%20digital%20nodes%2C%20robotic%20automation%20arms%2C%20logic%20flow%20diagrams%20with%20decision%20trees%2C%20AI-powered%20incident%20response%20playbooks%2C%20abstract%20security%20automation%20gears%20and%20neural%20network%20patterns%20on%20dark%20futuristic%20interface%2C%20professional%20technology%20illustration%20style&width=800&height=450&seq=soar-card&orientation=landscape"
                    alt="SOAR ve Logic Apps"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-purple-500 text-white text-xs font-semibold rounded-full">
                      Otomasyon
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0078D4] transition-colors">
                    Microsoft Sentinel SOAR: Olay Müdahale Süreçlerini Otomatize Etmek - Bölüm 1
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                    Automation Rules ve Logic Apps entegrasyonu ile güvenlik olaylarına otomatik yanıt verme stratejileri.
                  </p>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span className="flex items-center space-x-1">
                      <i className="ri-calendar-line"></i>
                      <span>3 Aralık 2025</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <i className="ri-time-line"></i>
                      <span>18 dk okuma</span>
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>

            {/* Maliyet Optimizasyonu */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/sentinel/sentinel-maliyet-optimizasyonu"
                className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer h-full"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20business%20person%20in%20suit%20protecting%20company%20budget%20with%20digital%20shield%2C%20modern%20corporate%20illustration%20with%20financial%20security%20theme%2C%20clean%20minimalist%20style%20with%20blue%20and%20white%20color%20scheme%2C%20no%20logos%20or%20brands%2C%20digital%20art%20concept%20showing%20cost%20optimization%20and%20financial%20protection&width=800&height=450&seq=sentinel-cost-card&orientation=landscape"
                    alt="Maliyet Optimizasyonu"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-teal-500 text-white text-xs font-semibold rounded-full">
                      Maliyet Optimizasyonu
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0078D4] transition-colors">
                    Sentinel Maliyet Optimizasyonu: Log Yönetimi ve Bütçe Kontrolü
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                    Data Lake Tier, Commitment Tier ve uzun vadeli saklama stratejileri ile maliyet optimizasyonu.
                  </p>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span className="flex items-center space-x-1">
                      <i className="ri-calendar-line"></i>
                      <span>22 Kasım 2025</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <i className="ri-time-line"></i>
                      <span>15 dk okuma</span>
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>

            {/* Kurulum Rehberi */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <Link
                to="/sentinel/sentinel-kurulum-rehberi"
                className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer h-full"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20cybersecurity%20operations%20center%20with%20multiple%20monitors%20displaying%20security%20dashboards%20and%20data%20analytics%2C%20modern%20tech%20workspace%20with%20blue%20ambient%20lighting%2C%20clean%20minimalist%20design%20showing%20SIEM%20setup%20and%20configuration%2C%20digital%20security%20concept%20illustration%20with%20network%20visualization&width=800&height=450&seq=sentinel-setup-card&orientation=landscape"
                    alt="Sentinel Kurulum"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-indigo-500 text-white text-xs font-semibold rounded-full">
                      Kurulum Rehberi
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0078D4] transition-colors">
                    Microsoft Sentinel Kurulum Rehberi: İlk 24 Saatte Atılması Gereken Adımlar
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                    Sentinel kurulumunun ilk 24 saatinde yapılması gereken kritik adımlar ve mimari kararlar.
                  </p>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span className="flex items-center space-x-1">
                      <i className="ri-calendar-line"></i>
                      <span>5 Mayıs 2025</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <i className="ri-time-line"></i>
                      <span>14 dk okuma</span>
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Harici Makaleler - mshowto.org */}
      {externalArticles.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20"
        >
          <div className="flex items-center space-x-3 mb-10">
            <div className="w-10 h-10 rounded-lg bg-[#0078D4]/10 flex items-center justify-center">
              <i className="ri-external-link-line text-[#0078D4] text-lg"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Önerilen Okumalar</h3>
              <p className="text-sm text-gray-500">mshowto.org&apos;da yayınlanan Sentinel makalelerim</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {externalArticles.map((article, index) => (
              <motion.div
                key={`ext-${index}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15, duration: 0.5 }}
              >
                <div className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent">
                  {/* Görsel Alanı */}
                  <div className="relative w-full h-56 overflow-hidden bg-gradient-to-br from-[#0a1628] to-[#0d2137]">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-contain object-center p-4 group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                    {/* Üst Badge */}
                    <div className="absolute top-4 left-4 flex items-center space-x-2">
                      <span
                        className={`${article.accentBg} text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap flex items-center space-x-1.5 shadow-lg`}
                      >
                        <i className={`${article.icon} text-sm`}></i>
                        <span>{article.tag}</span>
                      </span>
                    </div>

                    {/* Harici Badge */}
                    <div className="absolute top-4 right-4">
                      <span className="bg-white/20 backdrop-blur-sm text-white text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap flex items-center space-x-1">
                        <i className="ri-external-link-line text-xs"></i>
                        <span>{article.source}</span>
                      </span>
                    </div>

                    {/* Alt Bilgi */}
                    <div className="absolute bottom-4 left-4 right-4 flex items-center">
                      <span className="text-white/80 text-xs flex items-center space-x-1">
                        <i className="ri-calendar-line text-sm"></i>
                        <span>{article.date}</span>
                      </span>
                    </div>
                  </div>

                  {/* İçerik Alanı */}
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3 leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-sm text-gray-500 leading-relaxed mb-5">{article.description}</p>

                    {/* Alt Kısım */}
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center space-x-2">
                        <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${article.accent} flex items-center justify-center`}>
                          <i className="ri-shield-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-xs text-gray-500 font-medium">Sentinel Serisi</span>
                      </div>
                      <a
                        href={article.url}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="inline-flex items-center space-x-2 px-4 py-2 bg-[#0078D4] hover:bg-[#005A9E] text-white text-sm font-semibold rounded-lg transition-colors duration-300 cursor-pointer whitespace-nowrap"
                      >
                        <span>Makaleyi Oku</span>
                        <i className="ri-external-link-line text-sm"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      )}

      {/* Diğer Konular */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Diğer Konulara Göz Atın</h2>
            <p className="text-lg text-gray-600 mb-8">
              Microsoft güvenlik çözümleri hakkında daha fazla içerik keşfedin
            </p>
            <div className="flex items-center justify-center space-x-4 flex-wrap gap-y-3">
              <Link
                to="/intune"
                className="px-8 py-3 bg-orange-600 hover:bg-orange-700 text-white font-medium rounded-lg transition-colors whitespace-nowrap"
              >
                Intune
              </Link>
              <Link
                to="/edr"
                className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors whitespace-nowrap"
              >
                Microsoft EDR
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SentinelPage;
